import ActionType from 'actions/ActionType'
import { omit } from 'lodash'

export default (state = {}, action) => {
  switch (action.type) {
    case ActionType.SignupForm.ADD_SUCCESS:
      return {
        ...state,
        [action.payload.id]: action.payload,
      }
    case ActionType.SignupForm.LIST_SUCCESS:
      return Array.isArray(action.payload) ? action.payload.reduce(
        (formsByID, form) => {
          formsByID[form.id] = form
          return formsByID
        },
        { ...state }
      ) : {}
    case ActionType.SignupForm.READ_SUCCESS:
      return {
        ...state,
        [action.payload.id]: action.payload,
      }
    case ActionType.SignupForm.UPDATE_SUCCESS:
      return {
        ...state,
        [action.payload.id]: action.payload,
      }
    case ActionType.SignupForm.DELETE_SUCCESS:
      return omit(state, action.id)
    default:
      return state
  }
}
